// @ts-nocheck
import React, { useState } from "react";
import { RUTA_API_ALIAS, RUTA_API_AREAS, RUTA_API_USUARIOS, URL_API_SIA } from "../../Contantes/Constantes";
import { useBody } from "../../Body/state/BodyContext";
import axios from "axios";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import { AuthContext } from "./AuthContext";
import { EXTENSION_MAIL_INSTITUCIONAL } from "../../Contantes/Constantes";
import Keycloak from "../Keycloak";

export function ProvideAuth({ children }) {
    const authcontext = useProvideAuth();
    return (
        <AuthContext.Provider value={authcontext}>
            {children}
        </AuthContext.Provider>
    );
}

function useProvideAuth() {
    const [loading, setLoading] = useState(true);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const [impersonado, setImpersonado] = useState(false);
    const [user, setUser] = useState({
        roles: [],
        filiacion: null,
        name: null,
        email: null,
        uid: null,
        legajoPersonaUTN: null,
        uidnumber: null
    })

    React.useEffect(() => {
        if (Keycloak.isLoggedIn()) {
            fetchUsuario()
        }
    }, [Keycloak.isLoggedIn()])

    /**
     * Esta función setea los campos de información del usuario en la sesión.
     * En una primera instancia, lo utiliza el useEffect cuando un usuario se loguea en keycloak para setear toda su información
     * Luego esta función puede llegar a ser usada, si se tiene los permisos, para impersonarte con el token de otra persona
     * @param impersonated array de información de un usuario el cual se quiere impersonar
     * @param permisos array de roles del realm FRBA
     */
    const fetchUsuario = (impersonated = null, permisos = null) => {
        if (impersonated)
            setInfoUsuario(impersonated, permisos)
        else
            setInfoUsuario(Keycloak._kc.tokenParsed, Keycloak._kc.resourceAccess.sinap.roles)
    }

    /**
     * Set de toda la información necesaria del usuario
     * @param info array de información de un usuario
     * @param permisos array de roles del realm FRBA
     */
    const setInfoUsuario = (info, permisos) => {
        setUser(prevState => ({
            ...prevState,
            roles: permisos,
            filiacion: info.filiacion ? info.filiacion : null,
            name: info.name ? info.name : null,
            email: info.email ? info.email : null,
            uid: info.username ? info.username : null,
            legajoPersonaUTN: info.legajoPersonaUTN ? info.legajoPersonaUTN : null,
            uidnumber: info.id ? info.id : null
        }))
        setImpersonado(false);
        setLoading(false)
    }

    const handleImpersonate = async (uid) => {
        let estado = 0

        await axiosInstance({
            method: 'GET',
            url: RUTA_API_USUARIOS + '/keycloak/impersonar/' + uid
        }).then(response => {
            fetchUsuario({
                filiacion: response.data.filiacion,
                name: response.data.name,
                email: response.data.email,
                username: response.data.uid,
                legajoPersonaUTN: response.data.legajoPersonaUTN,
                id: response.data.uidnumber
            }, response.data.roles[0])
            setImpersonado(true)
            estado = 1
        }).catch(error => {
            if (error.response.status !== 400)
                estado = 0
            else {
                setImpersonado(false);
                estado = 2
            }
        }
        ).catch(error => {
            alert("Ocurrió un error fatal (Código de error: 00060)")
        })
        return estado;
    }

    const unImpersonate = () => {
        if (Keycloak.isLoggedIn()) {
            fetchUsuario();
        }
        setImpersonado(false);
    }

    const isLogedIn = () => {
        return user.uid !== null
    }

    const hasRole = (roles) => {
        if (!roles) {
            return false;
        }
        return roles.every((role) => user.roles.includes(role));
    }

    const masDeUnaFiliacion = () => {
        if (user.filiacion !== null)
            return user.filiacion.length > 1;
        else
            return Keycloak.masDeUnaFilicicion()
    }

    const esFiliacion = (tipo) => {
        if (user.filiacion !== null)
            return user.filiacion.includes(tipo)
        else
            return Keycloak.esFiliciaion(tipo)
    }

    return {
        loading,
        setLoading,
        user,
        fetchUsuario,
        isLogedIn,
        hasRole,
        masDeUnaFiliacion,
        esFiliacion,
        handleImpersonate,
        impersonado,
        unImpersonate
    };
}
